import React from 'react';

// Base
import CardPlaceholder from '../../../../../base/card_placeholder';

export default class Loading extends React.PureComponent {
  render() {
    return (
      <CardPlaceholder
        avatarSize='md'
        lines={4}
        color='dark'
        className='min-height-0 margin-bottom-10'
        isOrganization
        useAvatar
      />
    )
  }
}